import PropTypes from 'prop-types';
import { megaMenuPropTypes } from './components/MegaMenu/MegaMenuPropTypes';
export const navPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    badge: PropTypes.string,
    breakpoint: PropTypes.shape({
      mobile: PropTypes.bool,
      desktop: PropTypes.bool
    }),
    variant: PropTypes.string,
    items: megaMenuPropTypes.items
  })),
  isMobileOpen: PropTypes.bool,
  isSearching: PropTypes.bool
};